import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { Close, Search, SearchOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { BaseButton, InputAppearance, InputShape, InputSize } from '@lyearn/ui';
import { SearchBar } from '@/components/SearchBar';

import { inputStyles } from './styles';
import { FilterSearchProps } from './types';

const SEARCH_CONFIG: {
  [key: string]: {
    appearance?: InputAppearance;
    shape?: InputShape;
    size?: InputSize;
  };
} = {
  mobile: {
    appearance: 'filled',
    shape: 'square',
    size: 'medium',
  },
  desktop: {
    size: 'medium',
    shape: 'square',
  },
};

const FilterSearch = (props: FilterSearchProps) => {
  const { isMobile } = useScreen();
  const { t } = useTranslation();
  const searchConfig = isMobile ? SEARCH_CONFIG.mobile : SEARCH_CONFIG.desktop;
  const { onChange, value, placeholder = t('Common:Search') } = props;

  return (
    <SearchBar
      autoFocus
      appearance={searchConfig.appearance}
      className={cn({
        [inputStyles]: !isMobile,
        'flex items-center justify-center border-none': isMobile,
      })}
      endAdornment={
        isMobile ? (
          <BaseButton className="h-24 w-28 min-w-0 rounded-full p-0" onClick={() => onChange('')}>
            <Close className="h-24 w-24" fillColorToken="icon-secondary" />
          </BaseButton>
        ) : null
      }
      placeholder={placeholder}
      shape={searchConfig.shape}
      size={props.size ?? searchConfig.size}
      startAdornment={
        isMobile ? (
          <Search className="h-24 w-24" fillColorToken="icon-secondary" />
        ) : (
          <SearchOutline className="h-20 w-20 flex-shrink-0" fillColorToken="icon-placeholder" />
        )
      }
      value={value}
      variant="body-short-02"
      onChange={onChange}
    />
  );
};

export default FilterSearch;
